export default {"src":"/_next/static/media/roundtable.28c85fa8.svg","height":96,"width":96};